import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useState } from "react";
import neopharm from "../../Logo/Logo_Neopharm-Eng.gif";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Grid } from "@mui/material";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { MainContext } from "../../context/OpenInvoice";
import { RolesContext } from "../../context/User";
import LogOut from "../LogOut";
import backgroundImg from "../../images/cover.png";

export default function NavBarMobil() {
  const pages = [
    "portal",
    "linkopeninvoice",
    "getinvoice",
    "openorder",
    "roles",
    "about",
  ];
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [state, dispatch] = useContext(MainContext);
  const [showTooltip, setShowTooltip] = useState(false);
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const isHospitalOnly =
    stateroles.priorityCode === "D" ||
    stateroles.roles.includes("hospital");
  const [custNum, setCustNum] = useState(
    stateroles.userId ? stateroles.userId : ""
  );
  const navigate = useNavigate();

  const handleSelectClick = () => {
    setShowTooltip(showTooltip == true ? false : true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 5000);
  };

  const handleChange = (event) => {
    setCustNum(event.target.value);
    handleSubmit(event.target.value);
  };

  const handleSubmit = async (custnumber) => {
    try {
      const response = await axios.get(
        `/adminPermissions/change_cust_id/${custnumber}`,
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      if (error.response.status == 403) {
        navigate("/");
      }
    }
    dispatchroles({
      type: "USER_UPDATE",
      payload: {
        value: custNum,
        title: "userId",
      },
    });

    dispatch({
      type: "DATA_RESPONSE",
      payload: { value: [] },
    });
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (event) => {
    setAnchorElNav(null);
  };

  const navigationNavMenu = (selectedValue) => {
    navigate(`/${selectedValue}`);
    setAnchorElNav(null);
  };

  const styles = {
    appBar: {
      background: `url(${backgroundImg})`,
      backgroundSize: "cover",
    },
  };

  return (
    <AppBar
      position="static"
      sx={{ marginBottom: "0.5rem", height: "10vh", ...styles.appBar }}
    >
      <Container maxWidth="100%">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <img
              key={"imge20"}
              style={{
                height: "100%",
                width: "25%",
                marginLeft: "1rem",
                marginTop: "0.5rem",
              }}
              src={neopharm}
              alt="neopharmLogo"
            />
            {stateroles.userId ? (
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <FormControl
                    id={"uniqueId1"}
                    sx={{
                      minWidth: 120,
                      marginTop: "0.2rem",
                      backgroundColor: "#ffffff",
                      color: "#000000",
                      borderRadius: "5px",
                    }}
                    size="small"
                  >
                    {stateroles.userId && stateroles.customers.length > 1 ? (
                      <Tooltip title={stateroles.userCustDes}>
                        <Select
                          id="custNum-standard"
                          value={custNum ? custNum : stateroles.userId}
                          onChange={handleChange}
                        >
                          {stateroles.customers &&
                            stateroles.customers.map((component, index) => (
                              <MenuItem key={index} value={component.CUSTNAME}>
                                {component.CUSTDES}
                              </MenuItem>
                            ))}
                        </Select>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={stateroles.userCustDes}
                        open={showTooltip}
                      >
                        <TextField
                          id="outlined-basicFlied2"
                          defaultValue={stateroles.userCustDes}
                          variant="outlined"
                          disabled
                          size="small"
                          onClick={handleSelectClick}
                        />
                      </Tooltip>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenNavMenu}
                    color="inherit"
                    sx={{ paddingLeft: "3rem" }}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                    sx={{
                      display: { xs: "block", md: "none" },
                    }}
                  >
                    <MenuItem onClick={() => navigationNavMenu("portal")}>
                      <Typography textAlign="center">דף בית</Typography>
                    </MenuItem>
                    {(stateroles.roles.includes("linkopeninvoice") ||
                    stateroles.roles.includes("admin")) && stateroles.priorityCode === "A" ? (
                      <MenuItem
                        onClick={() => navigationNavMenu("linkopeninvoice")}
                      >
                        <Typography textAlign="center">
                          חשבוניות לתשלום
                        </Typography>
                      </MenuItem>
                    ) : null}
                    {(stateroles.roles.includes("getinvoice") ||
                    stateroles.roles.includes("admin")) && !isHospitalOnly ? (
                      <MenuItem onClick={() => navigationNavMenu("getinvoice")}>
                        <Typography textAlign="center">
                          חשבוניות/קבלות
                        </Typography>
                      </MenuItem>
                    ) : null}
                    {(stateroles.roles.includes("openorder") ||
                    stateroles.roles.includes("admin")) && !isHospitalOnly ? (
                      <MenuItem onClick={() => navigationNavMenu("openorder")}>
                        <Typography textAlign="center">הזמנות</Typography>
                      </MenuItem>
                    ) : null}
                    {(stateroles.roles.includes("shipping") ||
                    stateroles.roles.includes("admin")) && !isHospitalOnly ? (
                      <MenuItem onClick={() => navigationNavMenu("shipping")}>
                        <Typography textAlign="center">
                          תעודות משלוח{" "}
                        </Typography>
                      </MenuItem>
                    ) : null}
                    {(stateroles.roles.includes("roles") ||
                    stateroles.roles.includes("admin")) && !isHospitalOnly ? (
                      <MenuItem onClick={() => navigationNavMenu("roles")}>
                        <Typography textAlign="center">הרשאות</Typography>
                      </MenuItem>
                    ) : null}
                    {!isHospitalOnly && (
                    <MenuItem onClick={() => navigationNavMenu("about")}>
                      <Typography textAlign="center">מידע נוסף </Typography>
                    </MenuItem>
                    )}
                      <LogOut showProfil={true} />
                  </Menu>
                </Grid>
              </Grid>
            ) : null}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
